var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{staticClass:"card",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"card-body"},[_c('AIChatBot')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }